import { singleLineTextScopes } from '../../../common/fields/single-line-text';
import { commonIssueViewGranularScopes } from './fields-scopes';

export const summaryIssueViewScopes = {
	...singleLineTextScopes,
	granular: [...singleLineTextScopes.granular, ...commonIssueViewGranularScopes],
};
